// extracted by mini-css-extract-plugin
module.exports = {"heading":"antd-pro-containers-contacts-add-styles-heading"};